import { GameiomRequestSpin } from "gameiom/states/gameiom-request-spin";
import { Services } from "appworks/services/services";
import { SoundService } from "appworks/services/sound/sound-service";
import { Contract } from "appworks/utils/contracts/contract";

export class ThemeGameiomRequestSpin extends GameiomRequestSpin {
    protected startSpinning(): Contract<void> {
        Services.get(SoundService).customEvent(`reel_spin_start`);
        return super.startSpinning();
    }
}